import { EmergencyNotificationConfiguration } from '@dreryk/egabinet-emergency-notification-frontend-api';
import { PractitionerView } from '@dreryk/egabinet-personnel-frontend-api';

import { FormContextValues } from '@dreryk/react-common';

import { isEmpty } from '~libs.typescript';

import { EmergencyNotificationConfigurationFormBean } from './EmergencyNotificationConfigurationForm.types';
import { EmergencyNotificationInAppConfigurationResponseTeamPractitionerValue } from './fields/EmergencyNotificationInAppConfigurationResponseTeamPractitionersField.types';

export const withConfigurationEnabled = (
   controller: FormContextValues<EmergencyNotificationConfigurationFormBean & any>
): controller is FormContextValues<EmergencyNotificationConfigurationFormBean & { configurationEnabled: true }> => {
   return controller.watch('configurationEnabled');
};

export const withSmsConfigurationEnabled = (
   controller: FormContextValues<EmergencyNotificationConfigurationFormBean & any>
): controller is FormContextValues<
   EmergencyNotificationConfigurationFormBean & { configurationEnabled: true; smsConfigurationEnabled: true }
> => {
   return withConfigurationEnabled(controller) && controller.watch('smsConfigurationEnabled');
};

export const withInAppConfigurationEnabled = (
   controller: FormContextValues<EmergencyNotificationConfigurationFormBean & any>
): controller is FormContextValues<
   EmergencyNotificationConfigurationFormBean & { inAppConfigurationEnabled: true }
> => {
   return withConfigurationEnabled(controller) && controller.watch('inAppConfigurationEnabled');
};

export const formInitializer = (
   emergencyNotificationConfiguration: EmergencyNotificationConfiguration,
   practitioners: PractitionerView[]
): EmergencyNotificationConfigurationFormBean => {
   const smsConfigurationEnabled = Boolean(emergencyNotificationConfiguration.smsConfiguration.enabled);
   const inAppConfigurationEnabled = Boolean(emergencyNotificationConfiguration.inAppConfiguration.enabled);

   if (!smsConfigurationEnabled && !inAppConfigurationEnabled) {
      return {
         configurationEnabled: false,
      };
   }

   return {
      configurationEnabled: true,
      ...(emergencyNotificationConfiguration.smsConfiguration.enabled
         ? {
              smsConfigurationEnabled: true,
              messageCustomizablePart: isEmpty(
                 emergencyNotificationConfiguration.smsConfiguration.messageCustomizablePart
              )
                 ? null
                 : emergencyNotificationConfiguration.smsConfiguration.messageCustomizablePart,
              contactPersons: emergencyNotificationConfiguration.smsConfiguration.contactPersons.map(
                 (contactPerson) => ({
                    name: contactPerson.name,
                    phoneNumber: contactPerson.phoneNumber,
                 })
              ),
           }
         : {
              smsConfigurationEnabled: false,
           }),
      ...(emergencyNotificationConfiguration.inAppConfiguration.enabled
         ? {
              inAppConfigurationEnabled: true,
              responseTeamPractitioners: {
                 selector: [],
                 value: emergencyNotificationConfiguration.inAppConfiguration.responseTeamPractitionerIds.reduce(
                    (result, practitionerId) => {
                       const foundPractitioner = practitioners.find(
                          (practitioner) => practitioner.id === practitionerId.asNumber()
                       );
                       if (foundPractitioner) {
                          result.push({
                             practitioner: foundPractitioner,
                          });
                       }

                       return result;
                    },
                    [] as EmergencyNotificationInAppConfigurationResponseTeamPractitionerValue[]
                 ),
              },
           }
         : {
              inAppConfigurationEnabled: false,
           }),
   };
};
